import React, { useState } from 'react'
import { Table, Button, Form, Modal, Input, message, Avatar } from 'antd'
import Icon, { PlusOutlined, SearchOutlined } from '@ant-design/icons'
// import Icon from '@ant-design/icons'
import styled from 'styled-components'

import PropTypes from 'prop-types'
import KitchenForm from './KitchenForm'
// import Genres from '../shared/Genres'
const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledInput = styled(Input)`
  width: 256px;
`

const StyledAvatar = styled.img``

const Kitchens = ({
  kitchens,
  addKitchenHandler,
  updateKitchenHandler,
  deleteKitchenHandler
}) => {
  const [form] = Form.useForm()
  const [formForEdit] = Form.useForm()
  const [modalVisible, setModalVisible] = React.useState(false)
  const [kitchenItem, setKitchenItem] = React.useState(null)
  const [editModal, setEditModal] = React.useState(false)
  const [deleteModal, setDeleteModal] = React.useState(false)
  const [searchKitchen, setSearchKitchen] = React.useState(null)

  const [listKitchens, setListKitchens] = React.useState(null)

  const [audioFile, setAudioFile] = useState(null)
  const [imageFile, setImageFile] = useState(null)
  const audioFileRef = React.useRef()
  const imageFileRef = React.useRef()

  React.useEffect(() => {
    const descriptiveKitchens = kitchens.map(kitchen => {
      return {
        id: kitchen.id,
        index: kitchen.index,
        kitchen: kitchen.kitchen,
        link2Audio: kitchen.link2Audio,
        link2Image: kitchen.link2Image,
        status: kitchen.status
      }
    })
    let searchArray = descriptiveKitchens

    if (searchKitchen) {
      searchArray = searchArray.filter(kitchen => {
        return kitchen.kitchen?.toLowerCase().includes(searchKitchen)
      })
    }

    setListKitchens(searchArray)
  }, [kitchens, searchKitchen])

  const columns = [
    {
      title: '',
      width: '1%',
      render: item => (
        <div
          style={{
            background: item.status === 'active' ? '#44FB82' : '#D4D4D4',
            height: '60px',
            width: '20px',
            margin: '-10px'
          }}
        ></div>
      )
    },
    // {
    //   title: 'Фото',
    //   width: '5%',
    //   render: (item) => {
    //     return (
    //      <>
    //       <Avatar shape="square" size={64} src={item.photo}/>
    //      </>
    //    );
    //   },
    // },
    {
      title: 'Очередность',
      dataIndex: 'index',
      width: '2%'
    },
    // {
    //   title: 'Фото',
    //   width: '5%',
    //   render: item => {
    //     return (
    //       <>
    //         <img src={item.link2Image} />
    //       </>
    //     )
    //   }
    // },
    {
      title: 'Фото',
      width: '5%',
      render: item => {
        return (
          <>
            <Avatar shape="square" size={64} src={item.link2Image} />
          </>
        )
      }
    },
    {
      title: 'Дорожка',
      width: '5%',
      render: item => {
        let audioLink = item.link2Audio
        if (!audioLink.startsWith('https://')) {
          audioLink = 'https://' + audioLink
        }
        return (
          <audio controls="controls">
            <source src={audioLink} type="audio/mpeg" />
          </audio>
        )
      }
    },
    {
      title: 'Название предмета',
      dataIndex: 'kitchen',
      width: '5%'
    },
    {
      title: 'Действие',
      width: '20%',
      render: item => (
        <>
          <span>
            <Button
              type="link"
              onClick={() => {
                formForEdit.resetFields()
                setEditModal(true)
                setKitchenItem(item)
              }}
            >
              Редактировать
            </Button>
            <Button
              danger
              type="link"
              onClick={() => {
                setDeleteModal(true)
                setKitchenItem(item)
              }}
            >
              Удалить
            </Button>
          </span>
        </>
      )
    }
  ]

  return (
    <>
      <Table
        dataSource={listKitchens}
        columns={columns}
        rowKey={item => item.id}
        title={() => (
          <StyledHeaderContainer>
            <StyledInput
              prefix={<SearchOutlined />}
              placeholder="Название"
              onChange={e => {
                setSearchKitchen(e.target.value.toLowerCase())
              }}
            />

            <Button type="primary" onClick={() => setModalVisible(true)}>
              <PlusOutlined /> Новый предмет
            </Button>
          </StyledHeaderContainer>
        )}
      />
      <Modal
        open={modalVisible}
        title="Новый предмет"
        okText="Создать"
        cancelText="Отмена"
        onCancel={() => {
          form.resetFields()
          setModalVisible(false)
          setAudioFile(null)
          setImageFile(null)
          audioFileRef.current.value = null
          imageFileRef.current.value = null
        }}
        onOk={() => {
          if (audioFile !== null) {
            if (imageFile !== null) {
              addKitchenHandler(
                form,
                setModalVisible,
                audioFile,
                imageFile,
                setAudioFile,
                setImageFile,
                audioFileRef,
                imageFileRef
              )
            } else {
              message.error('Пожалуйста, выберите Изображение')
            }
          } else {
            message.error('Пожалуйста, выберите Аудио файл')
          }
        }}
      >
        <KitchenForm
          setAudioFile={setAudioFile}
          setImageFile={setImageFile}
          audioFileRef={audioFileRef}
          imageFileRef={imageFileRef}
          form={form}
        />
      </Modal>
      {editModal && (
        <Modal
          open={editModal}
          onCancel={() => {
            setEditModal(false)
            setAudioFile(null)
            setImageFile(null)
            audioFileRef.current.value = null
            imageFileRef.current.value = null
          }}
          onOk={() => {
            updateKitchenHandler(
              formForEdit,
              kitchenItem.id,
              setEditModal,
              audioFile,
              imageFile,
              setAudioFile,
              setImageFile,
              audioFileRef,
              imageFileRef
            )
          }}
        >
          <KitchenForm
            form={formForEdit}
            kitchen={kitchenItem.kitchen}
            index={kitchenItem.index}
            status={kitchenItem.status}
            setAudioFile={setAudioFile}
            setImageFile={setImageFile}
            audioFileRef={audioFileRef}
            imageFileRef={imageFileRef}
          />
        </Modal>
      )}
      {deleteModal && (
        <Modal
          open={deleteModal}
          onCancel={() => {
            setDeleteModal(false)
          }}
          onOk={() => deleteKitchenHandler(kitchenItem.id, setDeleteModal)}
        >
          <h3>Вы действительно хотите удалить '{kitchenItem.kitchen}' ?</h3>
        </Modal>
      )}
    </>
  )
}

Kitchens.propTypes = {
  kitchens: PropTypes.arrayOf(PropTypes.object).isRequired,
  addKitchenHandler: PropTypes.func.isRequired,
  updateKitchenHandler: PropTypes.func.isRequired
}

export default Kitchens
